


















import { defineComponent, useContext } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { url } from '~/utils';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
  },
  setup() {
    const { i18n } = useContext();

    const headerMenu = [
      {
        title: i18n.t('College-04.categoryList.headerTitle').toString(),
        icon: 'wine-college-all',
        to: url('COLLEGE_CATEGORY_LIST'),
      },
      {
        title: i18n.t('College-03.list.titleJp').toString(),
        icon: 'young-leaf',
        to: url('COLLEGE_BASIC_LIST'),
      },
      {
        title: i18n.t('College-01.list.titleJp').toString(),
        icon: 'action-location',
        to: url('COLLEGE_PRODUCING_AREA_LIST'),
      },
      {
        title: i18n.t('College-02.quiz.title.header').toString(),
        spTitle: i18n.t('College-02.quiz.title.spHeader').toString(),
        icon: 'quiz',
        to: url('COLLEGE_QUIZ_DAILY'),
      },
    ];

    return { headerMenu };
  },
});
